/**
 * Enum đánh giá theo
 * Created by: nvcuong1 09/05/2025
 */
export default {
    DeliverDecision: 1, // Quyết định giao  
    BeginningEstimate: 2 // Dự toán đầu năm
};
